@if (isLoading) {
  <div>Loading...</div>
}
@if (displayHTML) {
  <div [innerHTML]="displayHTML"></div>
} @else {
  <p>{{ message }}</p>
}
